import { consolidationCartonPurchasedLabelSchema } from "@redotech/redo-fulfillment-operations-common/consolidation-carton-label";
import { RateSchema } from "@redotech/redo-fulfillment-rate-common/outbound-labels";
import * as z from "zod";
import { consolidationCartonLabelInputSchema } from "./consolidation-carton-label-common";

// Retired in favor of save/quote. Kept so a browser tab loaded before the
// deploy gets a recoverable "refresh" response instead of an unknown method.
export const prepareConsolidationCartonLabel = {
  name: "prepareConsolidationCartonLabel" as const,
  mutates: true,
  input: consolidationCartonLabelInputSchema,
  output: z.object({
    purchasedLabel: consolidationCartonPurchasedLabelSchema.nullable(),
    rates: z.array(RateSchema),
  }),
};
